import missedCallStrategy from "../details/receive/missed.call.strategy.constans";
import * as angular from 'angular';
import {reloadCurrentRoute} from '../../../../../src/app/shared/utils/navigate-force-reload';

class PhoneSettings {
    [x: string]: any;
 	 static $inject = ['InboundNumbersService','$stateParams','Toast','$state','$aside','$location','$translate', 'AmplitudeService', 'AuthService', 'Router'];
    constructor(InboundNumbersService, $stateParams, Toast, $state, $aside, $location, $translate, AmplitudeService, AuthService, Router) {
        this.InboundNumbersService = InboundNumbersService;
        this.$stateParams = $stateParams;
        this.toast = Toast;
        this.state = $state;
        this.$aside = $aside;
        this.$location = $location;
        this.$translate = $translate;
        this.receiveCallConfiguration = "receiveCallConfiguration";
        this.forwardCallConfiguration = "forwardCallConfiguration";
        this.dontAcceptCallConfiguration = "dontAcceptCallConfiguration";
        this.missedCallStrategy = "missedCallStrategy";
        this.amplitude = AmplitudeService;
        this.AuthService = AuthService;
        this.router = Router;
        this.voiceGlobalMessagesConfig = [{
          type: 'welcomeMessage',
          description: 'PHONE.MESSAGES.ROW_DESCRIPTION_WELCOME_MESSAGE',
          header: 'PHONE.MESSAGES.ROW_HEADER_WELCOME_MESSAGE',
          canBeEnabled: true
        }, {
          type: 'voiceMailDrop',
          description: 'PHONE.MESSAGES.ROW_DESCRIPTION_VOICEMAIL_DROP',
          header: 'PHONE.MESSAGES.ROW_HEADER_VOICEMAIL_DROP',
          canBeEnabled: true,
          permission: 'VOICE_MAIL_DROP_PERMISSION'
        }, /*{
          type: 'onHold',
          description: 'PHONE.MESSAGES.ROW_DESCRIPTION_ON_HOLD',
          header: 'PHONE.MESSAGES.ROW_HEADER_ON_HOLD',
          canBeEnabled: true
        }*/];
    }

    $onInit() {
        this.user = this.AuthService.currentUser();
        this.amplitude.logEvent('Panel: Page View: Inbound settings');
        this.msisdn.initialLabel = this.msisdn.label;
        this.isNew = this.$stateParams.isNew;

        if (this.isNew) this.$location.search('isNew', null);
        if (this.number[this.missedCallStrategy]) {
            this.number[this.receiveCallConfiguration][this.missedCallStrategy] = this.number[this.missedCallStrategy];
        }
        Object.keys(this.number).forEach(key => {
            if (!angular.isObject(this.number[key])) {
              return;
            }
            else if (this.number[key]['checked']) {
                this.number[key] = Object.assign({}, this.number[key], {checked: true});
            } else {
                this.number[key] = Object.assign({}, this.number[key], {checked: false});
            }
        });
      this.activeMissedCall = this.isActiveMissedCall();
    }

    check(value: string) {
        if (this.isEmptyForwardCallConfigurationData(value)) {
            this.$aside({
                animation: "am-slide-right", placement: "right", container: "body",
                template: "<details-forward hide='$hide()' " +
                "settings='$ctrl.number.forwardCallConfiguration' " +
                "msisdnid='" + this.msisdn.id + "' " +
                "class='aside col-lg-3 p-a-0 max-w-500' layout>" +
                "</details-forward>"
            });
        } else {
          const currentMissedCallStrategy = this.number.missedCallStrategy;

          Object.keys(this.number).forEach((key) => {
            if(angular.isObject(this.number[key]) && !!this.number[key].checked) {
              this.number[key] = {...this.number[key], checked: false };
            }

            if(key === this.receiveCallConfiguration) {
              this.number[key] = {...this.number[key], missedCallStrategy: this.number.missedCallStrategy};
            }

            return this.number[key];
          });

          this.number = {
            ...this.number,
            [value]: {
              ...this.number[value],
              checked: !this.number[value].checked
            },
            missedCallStrategy: currentMissedCallStrategy
          };
          this.InboundNumbersService.setNumberSettings({id: this.msisdn.id}, this.number, () => {
            this.toast.success('CHANGES_SAVED');
            reloadCurrentRoute(this.router);
          });
        }
    }

    isEmptyForwardCallConfigurationData(value) {
        return value === this.forwardCallConfiguration && this.number[value].phoneNumber === "";
    }

    changeMissedCall() {
      if (this.isActiveMissedCall()) {
        this.number.receiveCallConfiguration.missedCallStrategy = 'DO_NOT_CALL_BACK';
        this.save('DO_NOT_CALL_BACK');
      } else {
        this.number.receiveCallConfiguration.missedCallStrategy = 'CALL_BACK_WITH_HIGHEST_PRIORITY';
        this.save('CALL_BACK_WITH_HIGHEST_PRIORITY');
      }
      this.activeMissedCall = this.isActiveMissedCall();
    }

    isActiveMissedCall() {
      return this.number.receiveCallConfiguration.missedCallStrategy === 'CALL_BACK_WITH_HIGHEST_PRIORITY';
    }

    save(missedCallStrategyState) {
      this.number = {...this.number, missedCallStrategy: missedCallStrategyState};
      this.InboundNumbersService.setNumberSettings(
          { id: this.msisdn.id },
          this.number, () => {
          this.toast.success('CHANGES_SAVED');
        });
    }

    isReturnCallEnabled() {
        return this.number[this.receiveCallConfiguration][this.missedCallStrategy] === missedCallStrategy.CALL_BACK_WITH_HIGHEST_PRIORITY;
    }

    reloadState() {
      reloadCurrentRoute(this.router);
    }

    settingsChanged() {
      this.toast.success('CHANGES_SAVED');
    }

    clickOnDetailsReceive() {
      angular.element('#details-receive').triggerHandler('click');
    }

    upgradeAccount() {
      this.router.navigateByUrl('/my-account');
    }
}

export default {
    controller: PhoneSettings,
    template : require('./settings.numbers.settings.html'),
    bindings: {number: '<', msisdn: '<', plan: '<', hasAutoAppliedEeaMsisdn: '<'}
};
